import React from 'react';
import {
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import { useTranslation } from '@gamiphy/react-i18n';
import { CashbackPopupsStore } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups';

const DoNotShowAgain: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      sx={{
        m: '0 !important',
      }}
      label={(
        <Typography fontSize={14} fontWeight={500}>
          {t('cashbackPopup.dismiss', 'Don\'t show again')}
        </Typography>
      )}
      control={(
        <Checkbox
          onChange={(e) => CashbackPopupsStore.setCashbackPopupDismissed(e.target.checked)}
          value={CashbackPopupsStore.cashbackPopupDismissed}
          color="primary"
          size="large"
          sx={{
            mr: 0.5,
            color: '#D0D5DD',
            width: 16,
            height: 16,
          }}
        />
      )}
    />
  );
};

export default observer(DoNotShowAgain);
